import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import styled from 'styled-components';
import config from '../config';

const DropzoneContainer = styled.div`
  margin-bottom: 34px;
  width: 100%;
  box-shadow: 0px 6px 18px 0 rgba(0, 0, 0, 0.04);
  background-color: #ffffff;
  height: auto;
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 0px;
  margin-top: 30px;
  flex-direction: column;
`;

export default class DropZone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'empty',
    };
  }

  getUploadParams = ({ file }) => {
    const { token, folder } = this.props;
    const fileName = file.name;

    const body = new FormData();
    body.append('file', file, fileName);

    return {
      url: `${config.BASE_URL}/uploads/${folder}`,
      headers: {
        authorization: `Bearer ${token}`,
        'x-region': config.REGION,
      },
      body,
    };
  };

  handleChangeStatus = ({ xhr }, status) => {
    if (status === 'done') {
      const { handleSuccess } = this.props;
      handleSuccess(JSON.parse(xhr.response));
    } else if (status === 'error_upload' || status === 'aborted') {
      const { handleError } = this.props;
      if (handleError) {
        const msg =
          xhr && xhr.responseText
            ? JSON.parse(xhr.responseText)?.message ?? 'Upload failed'
            : 'Upload failed';
        handleError(msg);
      }
    }
  };

  render() {
    const { height } = this.props;
    return (
      <DropzoneContainer>
        <Dropzone
          autoUpload
          getUploadParams={this.getUploadParams}
          onChangeStatus={this.handleChangeStatus}
          multiple={false}
          canCancel={false}
          inputContent={(files, extra) =>
            extra.reject ? 'Only .csv files are allowed' : 'Drag CSV File or Click to Browse'
          }
          accept=".csv"
          styles={{
            dropzone: {
              height: height || '200px',
            },
          }}
        />
      </DropzoneContainer>
    );
  }
}

DropZone.propTypes = {
  token: PropTypes.string,
  folder: PropTypes.string,
  handleSuccess: PropTypes.func,
  handleError: PropTypes.func,
  height: PropTypes.string,
};

DropZone.defaultProps = {
  token: null,
  folder: null,
  handleSuccess: null,
  handleError: null,
  height: null,
};
